
import React, { useState, useRef, useEffect } from "react";
import {
  UilPlus,
  UilExport,
  UilSearch,
  UilAngleDown,
  UilCheck,
} from "@iconscout/react-unicons";
import AddMovieModal from "components/AddMovieModal"; 
import useSWR from "swr";

export default function MovieBoxControls() {
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("All statuses");
  const [isAddMenuOpen, setAddMenuOpen] = useState(false);
  const dropdownRef = useRef();
  const addMenuRef = useRef();
  const { data: status } = useSWR('/entertainment/movie-box/statuses')

  const statuses = status?.data

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownOpen(false);
      }
      if (addMenuRef.current && !addMenuRef.current.contains(e.target)) {
        setAddMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="w-full bg-white p-4 md:p-6 rounded-xl shadow mb-6">
      <div className="flex flex-col md:flex-row md:items-center justify-between mb-4">
        <h1 className="text-xl md:text-2xl font-bold text-gray-800">
          MovieBox
        </h1>
        <div className="flex space-x-2 mt-4 md:mt-0">
          <button className="flex items-center bg-white text-secondary border border-primary px-4 py-2 rounded-md ">
            <UilExport className="mr-2" size={18} />
            Export
          </button>

          <div className="relative" ref={addMenuRef}>
            <button
              onClick={() => setAddMenuOpen((prev) => !prev)}
              className="flex items-center bg-primary text-white px-4 py-2 rounded-md hover:bg-primary-dark transition"
            >
              <UilPlus className="mr-2" size={18} />
              Add Movie
            </button>

            <AddMovieModal
              isOpen={isAddMenuOpen}
              onClose={() => setAddMenuOpen(false)}
            />
          </div>
        </div>
      </div>

      {/* Search + Filter */}
      <div className="flex flex-col md:flex-row md:items-center space-y-4 md:space-y-0 md:space-x-4">
        <div className="flex items-center bg-gray-100 px-3 py-2 rounded-md w-full md:w-1/6">
          <UilSearch className="text-gray-500 mr-2" />
          <input
            type="text"
            placeholder="Search "
            className="bg-transparent w-full focus:outline-none text-sm text-gray-700"
          />
        </div>

        <div className="relative" ref={dropdownRef}>
          <button
            onClick={() => setDropdownOpen((prev) => !prev)}
            className="flex items-center bg-gray-100 px-4 py-2 rounded-md text-sm text-gray-700"
          >
            {selectedStatus}
            <UilAngleDown
              className={`ml-2 transition-transform ${isDropdownOpen ? "rotate-180" : ""
                }`}
            />
          </button>

          {isDropdownOpen && (
            <div className="absolute z-20 mt-2 w-48 bg-white border border-gray-200 rounded-md shadow-md">
              <ul className="text-sm text-gray-700 py-1">
                {statuses.map((status) => (
                  <li
                    key={status}
                    onClick={() => {
                      setSelectedStatus(status);
                      setDropdownOpen(false);
                    }}
                    className="px-4 py-2 hover:bg-gray-100 flex justify-between items-center cursor-pointer"
                  >
                    {status}
                    {selectedStatus === status && (
                      <UilCheck className="text-primary" size={16} />
                    )}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
